/**
 * Add parent class to group-block elements containing package buttons
 * Adds different classes based on different button types
 */

(function() {
  function addClassToButtonParents() {
    // Button classes and their corresponding parent class names
    const buttonClassMap = {
      'standard-btn': 'standard-btn-parent',
      'premium-btn': 'premium-btn-parent',
      'premium-women-btn': 'premium-women-btn-parent',
      'premium-men-btn': 'premium-men-btn-parent'
    };
    
    // Process each button class
    Object.keys(buttonClassMap).forEach(buttonClass => {
      // Find all elements with each button class
      const buttons = document.querySelectorAll(`.${buttonClass}`);
      
      buttons.forEach((button, index) => {
        // Find the parent div with class 'group-block'
        const parentGroupBlock = button.closest('.group-block');
        
        if (parentGroupBlock) {
          // Add the specific parent class based on button type
          const parentClass = buttonClassMap[buttonClass];
          parentGroupBlock.classList.add(parentClass);
          
          // Also add a general class for all button parents
          parentGroupBlock.classList.add('package-btn-parent');
          
          // Add index-based class for unique identification if needed
          // e.g., 'standard-btn-parent-0', 'standard-btn-parent-1', etc.
          parentGroupBlock.classList.add(`${parentClass}-${index}`);
        }
      });
    });
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addClassToButtonParents);
  } else {
    addClassToButtonParents();
  }

  // Also run when content is dynamically loaded (for Shopify theme editor)
  if (document.addEventListener) {
    document.addEventListener('shopify:section:load', () => {
      setTimeout(addClassToButtonParents, 100);
    });
    
    document.addEventListener('shopify:section:reorder', () => {
      setTimeout(addClassToButtonParents, 100);
    });
  }
})();
